// extracted by mini-css-extract-plugin
export default {"footer":"sBQt7XcbAgWTuNjRLfJp","links":"jdfZj30yV3cNXFyq0YHi","instagram":"k7psNC3PhjEZw9ro6K8t"};